import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import { FIRESTORE_PACKAGING_STOCKS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";

export const usePackagingStock = () => {
  const [packagingStocks, setPackagingStocks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);

    const packagingStocksRef = collection(
      firestore,
      FIRESTORE_REGIONS_TABLE,
      COMPANY_COUNTRY_CODE,
      FIRESTORE_PACKAGING_STOCKS_TABLE,
    );

    const q = query(packagingStocksRef, orderBy("size", "asc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const stocks = [];
        snapshot.forEach((doc) => {
          stocks.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setPackagingStocks(stocks);
        setIsLoading(false);
        setError(null);
      },
      (err) => {
        console.error("Error fetching packaging stocks:", err);
        setError(err.message);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  return {
    packagingStocks,
    isLoading,
    error,
  };
};
